// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__eIRI7","nav":"Dashboard_nav__9B7DB","navStudentInfo":"Dashboard_navStudentInfo__56Igy","progressContainer":"Dashboard_progressContainer__OV+FV"};